import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InboundservicesService } from 'src/app/diarydak/inbound/services/inboundservices.service';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { ToastrService } from 'ngx-toastr';
import { urlServices } from 'src/app/griviance/models/url.models';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HelperService } from 'src/app/common-service/helper.service';
import { OutboundService } from 'src/app/diarydak/outbound/services/outbound.service';
import { forkJoin } from 'rxjs';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { constantServices } from 'src/app/griviance/models/const.model';
import { ExcutiveService } from 'src/app/excucomm/service/excutive.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { encryptionService } from 'src/app/common-service/cedService';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from 'src/app/common-service/signup.service';


@Component({
  selector: 'viewreceiptse',
  templateUrl: './viewreceiptse.component.html',
  styleUrls: ['./viewreceiptse.component.css']
})
export class ViewreceiptseComponent implements OnInit {
  @ViewChild('closeModal') closeBtn: ElementRef<HTMLElement>;
  subscribe: Subject<any> = new Subject<any>();
  status: string;
  submitted = false;
  reassignbutton: boolean;
  assignbutton: boolean;
  receiptId: any;
  receiptData: any;
  f: any;
  evidanceArray: any = [];
  filteredexistingfilenumber: any = [];
  sectionshortname: any;
  downloadUrl: string;
  userArray: any = [];
  refForm: FormGroup;
  stateName: any;
  cityName: any;
  assigngedUserDetails: any = [];
  showDisposedbutton = false;
  statuses: any;
  processbtn = false;
  history: any;
  createNotesheetstatus: boolean=false;
  userData: any;
  showsearch: boolean;
  showradio: boolean;
  sectionList: any;
  subSectionList: any;
  patternNumber: string;
  shortname: string;
  academicYear: any = [];
  currentyear: number;
  refacademicyear: any;
  rowId = 10;
  pageId = 0;
  showtagBtn = false; showbtns = true;
  subcategoriesList: any = [];
  categoriesList: any = [];
  referenceValues: any = [];
  subcategoryValue: any;
  collegeList: any = [];
  
  
  nextyear: number;
  today: string;
  fileno: string;
  existingFilesList: any;
  responsePageCount: any;
  searchForm: FormGroup;
  refidvalue: any;
  showreference: boolean =false;
  showreference1: boolean =false;
  showcollege: boolean=false;
  subcategoryReference: any;
  docid: any;
  docpath: any;
  sectionName: any;
  assignReceiptForm: FormGroup;
  correctionSeekList: any = [];
  correctionDesignationList: any = [];
  personList: any = [];
  correctionPersonList: any = [];
  urgencyList: any = [];
  confidentialityList: any = [];
  obj: any;
  roleName: string;
  designation: any;
  showassign: boolean =false;
  email: string;
  sectionNames: any=[];
  primarywithsectionName: any=[];
  sectionid: any;
  resultSet: any=[];
  disablePerson : boolean = false;
  decryptReceiptId: any;
  decryptDispatchReceiptId: any;
  id: any;
  constructor(public signin: SignupService, public router: Router, public service: InboundservicesService,
              public fb: FormBuilder, public urls: urlServices, public usrmgtService: UsrmgtService, public aroute: ActivatedRoute,
              public helper: HelperService, public tostar: ToastrService,public outboundSer: OutboundService, public serverURL: ServerURLService,
              public ecConst: constantServices, public ecservice: ExcutiveService, public route: ActivatedRoute,
     public scconst: constantServices, public ced: encryptionService, public EncrDecr: EncrDecrService, public spinner: NgxSpinnerService) {


  }
  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => this.decryptReceiptId = params.id);
    this.route.params.subscribe((params: Params) => this.decryptDispatchReceiptId = params.receiptid);
    this.id = this.EncrDecr.get(this.serverURL.secretKey, this.decryptReceiptId);
    this.receiptId = this.EncrDecr.get(this.serverURL.secretKey,this.decryptDispatchReceiptId);
    this.roleName=sessionStorage.getItem('selectedRole-usec');
    if (this.id !== '') {
      this.getReceiptById(this.id);
    }
    if(this.receiptId !==''){
      this.receiptId =this.receiptId;
      this.getHistoryOfReceipt(this.receiptId);
      
    }
    let d = new Date();
    let n = d.getFullYear();
    this.currentyear = n;
    
    this.nextyear = this.currentyear + 1;
    // 
    this.refacademicyear =this.currentyear + '-' + this.nextyear.toString().substr(-2);
    this.AllAcademicYearList();
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    let yyyy = today.getFullYear();

    this.today = dd + '-' + mm + '-' + yyyy;
    
    this.searchForm = this.fb.group({
      fileno: ['']
    });
    this.assignReceiptForm = this.fb.group({
      designation: ['', Validators.required],
      sectionExecuite: ['', Validators.required],
      comment:  ['', [Validators.required,this.noWhitespaceValidator]]

    });
    this.joinCalls();
    this.designation = JSON.parse(sessionStorage.getItem('userInfo-usec'))?.deg?.designationName;
  if(this.roleName === 'President'|| this.roleName === 'Secretary' || this.roleName === 'Secretary Incharge' || this.roleName === 'Joint Secretary' 
    || this.roleName === 'AFSecInCharge' || this.roleName === 'AdmsnIncharge' || this.roleName === 'AcademicIncharge' 
    || this.roleName === 'LegalSecInCharge' || this.roleName === 'AEIncharge' || this.roleName === 'ISecInCharge' 
    || this.roleName === 'RTISecInCharge' || this.roleName === 'ServerSecInCharge' || this.roleName === 'ARPMSecInCharge' 
    || this.roleName === 'PDMSSecInCharge' || this.roleName === 'InspAsstSecty' || this.roleName === 'MSAsstSecty' 
      || this.roleName === 'ARPMAsstSecty' || this.roleName === 'AcademicAsstSecty' || this.roleName === 'AdmsnAsstSecty' || this.roleName === 'PDMSAsstSecty' 
      || this.roleName === 'AEAssistantSecretary' || this.roleName === 'PDMSSectionOfficer' || this.roleName === 'LegalSectionOfficer' || this.roleName === 'RTISectionOfficer' 
      || this.roleName === 'AFSectionOfficer' || this.roleName === 'AESectionofficer' || this.roleName === 'AcademicSectionOfficer' || this.roleName === 'AdmsnSectionOfficer'
      || this.roleName === 'RTIAssistantSectionOfficer'|| this.roleName === 'ARPMAssistantSectionOfficer' || this.roleName === 'AdmsnAssistantSectionOfficer'
      || this.roleName === 'AcademicAssistantSectionOfficer' || this.roleName === 'PDMSAssistantSectionOfficer' || this.roleName === 'AFAssistantSectionOfficer' 
      || this.roleName === 'AEAssistantSectionOfficer' || this.roleName === 'LegalAssistantSectionOfficer' || this.roleName === 'LegalRetainer' || this.roleName === 'RTILegalRetainer' 
      || this.roleName === 'Accountant' || this.roleName === 'DAK_Section_Executive' || this.roleName === 'Student Admission Executive' || this.roleName === 'AcademicExecutive' 
      || this.roleName === 'ServerSecExecutive' || this.roleName === 'PDMSExecutive' || this.roleName === 'RTIExecutive' || this.roleName === 'AdmsnSecExecutive' 
      || this.roleName === 'AFExecutive' || this.roleName === 'LegalExecutive' || this.roleName === 'AEExecutive' || this.roleName === 'ARPMSecExecutive') {
        this.getAllFwdReceiptById();
      } else {      
        this.signin.deleteOauthToken().subscribe((result: any) => {      
      });
      }
  }
  joinCalls() {
    const urgencyCall = this.outboundSer.getAllDispatchesUrgency();
    const confidentialityCall = this.outboundSer.getDispatchConfidentiality();

    forkJoin([urgencyCall, confidentialityCall]).pipe(takeUntil(this.subscribe)).subscribe(results => {
      
      this.urgencyList = results[0];
      this.confidentialityList = results[1];
    }, error => {
      console.log(error);
    });

  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  getReceiptById(id: any) {
    this.userData = JSON.parse(sessionStorage.getItem('userInfo-usec'));
    this.service.getReceiptDetailsByReceiptId2(id).pipe(takeUntil(this.subscribe)).subscribe((result: any) => {
      this.receiptData = result;
      
      if (this.receiptData.receiptFileNum === null) {
        this.showtagBtn = true;
        this.showbtns = false;
      } else {
        this.showtagBtn = false;
        this.showbtns = true;
      }
      if (this.receiptData.dakStatus.statusName === 'Disposed') {
        this.showbtns = false;
      }
      
      this.email =sessionStorage.getItem('email-Id');
        if (this.receiptData.receiptWorkflows.assignedToUserId.emailId === this.email) {
          this.showassign = true;
        } else {
          this.showassign = false;
        }
    });
  }

  getHistoryOfReceipt(id) {
    this.showDisposedbutton = false;
    this.service.getHistoryByReceiptId(id).pipe(takeUntil(this.subscribe)).subscribe((result: any) => {
      this.history = result;
      this.history.forEach((element,index) => {
        this.sectionid =JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId;
        if(this.sectionid != null) {
          if(element?.role?.section?.sectionId === this.sectionid){
            this.resultSet.push(element);
          }
        }
      });
    });
  }

  // getAllDCISections
  getSections() {
    this.service.getAllDCISections().pipe(takeUntil(this.subscribe)).subscribe((res: any) => {
      
      this.sectionList = res;      
      this.shortname = res[7].shortName;      
     this.helper.sortedData(this.sectionList, 'sectionName');
    }, error => {
      console.log(error);
    });
  }

  // getSubSections
  getSubSections(id: any) {
    this.service.getSubSections(id).pipe(takeUntil(this.subscribe)).subscribe(res => {
      
      this.subSectionList = res;
      this.helper.sortedData(this.subSectionList, 'name');
    }, error => {
      console.log(error);
    });
  }

  getCityId(city: any) {
    this.usrmgtService.getCityById(city).pipe(takeUntil(this.subscribe)).subscribe(((result: any) => {
      this.cityName = result.cityName;
    }));
  }
  getStateById(id) {
    this.usrmgtService.getStateById(id).pipe(takeUntil(this.subscribe)).subscribe((result: any) => {
      this.stateName = result.stateName;
    });
  }

  navigateBack() {
    if(this.aroute.snapshot.params.pathurl1 === 'dashboard') {
      this.router.navigate(['main/internal/outbound/se/dashboard']);
    } else if(this.aroute.snapshot.params.pathurl1 === 'trackNotesheetSecExec') {
      this.router.navigate(['main/internal/outbound/se/trackNotesheetSecExec']);
    } else if(this.aroute.snapshot.params.pathurl1 === 'trackNotesheet') {
      this.router.navigate(['main/internal/outbound/secInch/trackNotesheet']);
    } else  if(this.roleName ==='InspAsstSecty'||this.roleName ==='MSAsstSecty'||this.roleName ==='ARPMSecInCharge'||this.roleName ==='PDMSSecInCharge'||this.roleName ==='AdmsnIncharge'
    ||this.roleName ==='AcademicIncharge'||this.roleName ==='AEIncharge'||this.roleName ==='AFSecInCharge'||this.roleName ==='LegalSecInCharge'||this.roleName === 'RTISecInCharge'||this.roleName === 'ServerSecInCharge')
    this.router.navigate(['main/internal/outbound/secInch/secInchDispatchDashboard']);
    else if(this.roleName ==='Secretary' || this.roleName ==='Secretary Incharge' || this.roleName === 'Joint Secretary')
    this.router.navigate(['main/internal/outbound/CZsQVJe0x6/dispatchDashboard']);
    else if(this.roleName ==='President')
    this.router.navigate(['main/internal/outbound/president/dispatchDashboard']);
    else 
    this.router.navigate(['main/internal/outbound/se/dispatchDashboard']);
    sessionStorage.setItem("back", "back");
  }

  // Download
  public getDocumentId(id: any) {
    this.downloadUrl = this.urls.documentUrl + '?uuid=' + id.documentId;
  }

  viewDocuments(filePath:any, fileName: any) {    
    this.usrmgtService.getRandomKeyGeneratorForViewDocument().subscribe((data: any) => {
      const randomkeyKey = this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
      this.viewDocumentsAfterEncryptedfilePath(this.ced.encryptAesToString(filePath, randomkeyKey).toString(),fileName);
    }, error => {
      console.log(error);
    });
  }

  viewDocumentsAfterEncryptedfilePath(filePath:any, fileName: any) {  
    this.spinner.show();
    this.usrmgtService.ViewDocument(filePath).pipe().subscribe((result: any) => {
      this.spinner.hide();
      var blob = result;
      var fileURL = URL.createObjectURL(blob);
      if(fileName.split('.').pop().toLowerCase() === 'pdf') {
        window.open(fileURL);
      } else {
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = '_blank';
        a.download = fileName;
        a.click();
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  selectedCorrectionDesignation(data: any) {    
    this.correctionPersonList = [];
    this.disablePerson=false;
    this.assignReceiptForm.controls.sectionExecuite.setValue('', { onlySelf: true });
    this.correctionSeekList.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key === data) {
          this.correctionPersonList = item[key];
          
        }
      });
    });
    if(this.correctionPersonList.length===1){
      this.disablePerson=true;
      this.assignReceiptForm.patchValue({
        sectionExecuite : this.correctionPersonList[0].userId
      })
    }
  }
  assignReceiptToSectionExecutive() {
    
    this.submitted = true;

    if (this.assignReceiptForm.valid) {
      const obj = {
        receiptId: this.receiptId,
        sectionExecutiveId: this.assignReceiptForm.value.sectionExecuite,
        comments: this.assignReceiptForm.value.comment,
        roleName: sessionStorage.getItem('selectedRole-usec')
      }
      this.service.assignReceiptToAnyDesignation(obj).pipe(takeUntil(this.subscribe)).subscribe((result: any) => {
        this.router.navigate(['main/internal/inbound/sectionexecutive/dashboard']);
        this.tostar.success('Receipt Assigned Successfully', 'Success', {
          timeOut: 2000
        });
        this.resetValidations();
      }, error => {
        console.log(error);
      });
    }
  }
  resetValidations() {
    this.assignReceiptForm.reset();
    this.assignReceiptForm.controls.designation.setValue('', { onlySelf: true });
    this.assignReceiptForm.controls.sectionExecuite.setValue('', { onlySelf: true });
  }
  getAllFwdReceiptById(){
    this.service.getAllFwdReceiptById(this.receiptId).pipe(takeUntil(this.subscribe)).subscribe((res:any)=>{
      this.primarywithsectionName = [];
      res.forEach(element => {
        this.sectionName =element?.role?.section?.sectionName
        this.sectionNames.push(this.sectionName);
        this.primarywithsectionName.push(element);
        });
    },error=>{
      console.log(error);
      this.helper.errorMessage(error);
    })
  }
  // Destroy The Subscribe Dta
  ngOnDestroy() {
    this.subscribe.next();
    this.subscribe.complete();
  }

  AllAcademicYearList() {
    this.outboundSer.academicYearListByDispatch().pipe(takeUntil(this.subscribe)).subscribe((res: any) => {
      this.academicYear = res;
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }
}
